import React, { useState } from 'react';
import './ProductCardEx.scss';
import { GrDown, GrUp } from 'react-icons/gr';
import TextInput from '../TextInput';
import { Product } from '../../types/Product';
import ProductImage from '../ProductImage';
import { Price } from '../../types/Price';
import { Pallet, Stock } from '../../types/Stock';
import { ProductType } from '../../types/ProductType';
import _ from 'lodash';
import Button from '../Button';

import { OrderLine } from '../../types/Order';
import { lwRoundNumber, roundNumber } from '../../helpers/functions';
import { useDispatch, useSelector } from 'react-redux';
import { addToBasket } from '../../actions/Order';
import { useHistory } from 'react-router-dom';
import CONSTANTS  from '../../helpers/constants';
import TrashSvg from '../../assets/svgs/trash.svg';
import LWModal from '../Modal';
import MultiChoice from '../MultiChoice';
import { emailNotifyStock } from '../../actions/Email';
import { getCustomer } from '../../selectors/Customer';

type Props = {
  product?: Product | null;
  price?: Price | null;
  stock?: Stock | null;
  productType?: ProductType | null
};

const ProductCardEx = (props: Props) => {
  const { product, price, stock, productType } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const customer = useSelector(getCustomer);
  const [togglePack, setTogglePack] = useState(true);
  const [togglePallet, setTogglePallet] = useState(false);
  const [currentPacks, setCurrentPacks] = useState(null);
  const [currentSQMPacks, setCurrentSQMPacksInner] = useState(null);
  const [togglePalletPopUp, setTogglePalletPopUp] = useState<boolean>(false);
  const [currentPallet, setCurrentPallet] = useState<Pallet | null>(null);

  const [reference, setReference] = useState('');
  const [referencePallets, setReferencePallets] = useState('');
  const [orderLines, setOrderLines] = useState<OrderLine[]>([]);
  const [toggleMore, setToggleMore] = useState<boolean>(false);

  const onNotify = () => {
    dispatch(emailNotifyStock({
      customerName: customer?.NAME || 'N/A',
      productQuality: product?.quality_full_name || 'N/A',
      productColor: product?.colour_full_name || 'N/A',
      productSKU: product?.product_sku || 'N/A',
      rep_email: customer?.rep_email || 'N/A',
      rep_name: customer?.rep_name || 'N/A',
    }));
  };

  const setCurrentSQMPacks = (val: string) => {
    const num = lwRoundNumber(val);
    // @ts-ignore
    setCurrentSQMPacksInner(num);
    // @ts-ignore
    setCurrentPacks(Math.ceil(lwRoundNumber(num / product?.sqm_per_box)));
  };

  const onAddPackToOrderSummary = () => {
    const localOrderLines = [...orderLines];
    if (product && price && productType && currentPacks) {

      localOrderLines.push({
        product_sku: product.product_sku,
        product_quality: product.quality_full_name,
        product_type_code: product.product_type_code,
        product_type_code_name: productType.product_type_desc,
        quantity: currentPacks,
        half_roll: '',
        pallet_id: '',
        roll_id: '',
        length: 0,
        width: 0,
        item_price: price.unit_price,
        line_reference: reference,
        line_price: price.unit_price * currentPacks,
        line_discount: price.cut_price_discount,
        colour_full_name: product.colour_full_name,
      });
      setReference('');
      setCurrentSQMPacks('');
      setOrderLines(localOrderLines);
    }
  };

  const onAddPalletToOrderSummary = () => {
    const localOrderLines = [...orderLines];
    if (product && price && productType && currentPallet) {
      localOrderLines.push({
        product_sku: product.product_sku,
        quantity: currentPallet?.pallet_qty,
        length: 0,
        width: 0,
        half_roll: '',
        pallet_id: currentPallet?.pallet_id,
        roll_id: '',
        product_quality: product.quality_full_name,
        product_type_code: product.product_type_code,
        product_type_code_name: productType.product_type_desc,
        item_price: price.pallet_price,
        line_reference: referencePallets,
        line_price: price.pallet_price * currentPallet.pallet_qty,
        colour_full_name: product.colour_full_name,
        line_discount: price.roll_price_discount,
      });
      setOrderLines(localOrderLines);
      setReferencePallets('');
      setCurrentPallet(null);
    }
  };

  const totalQty = stock?.pallet?.find(p => p.pallet_batchno === 'TOTAL')?.pallet_qty || 0;

  const onSelectPallet = () => {
    setTogglePalletPopUp(false);
  };

  const onAddOrderSummaryToBasketAndContinue = () => {
    dispatch(addToBasket(orderLines));
    history.push(CONSTANTS.APP_ROUTES.DASHBOARD);
  };

  const onAddOrderSummaryToBasket = () => {
    dispatch(addToBasket(orderLines));
    history.push(CONSTANTS.APP_ROUTES.CART);
  };


  const onMinus = (index: number) => {
    let localOrderLines = [...orderLines];
    localOrderLines = localOrderLines.filter((or, i) => i !== index);
    setOrderLines(localOrderLines);
  };

  const getLocalUsedPacks = () => {
    let total = 0;
    orderLines.filter(o => o.product_sku === product?.product_sku).forEach((cur) => total += cur.quantity);
    return total;
  };

  const getOrderTotal = () => {
    let total = 0;
    orderLines.forEach(o => total += o?.line_price || 0);
    return total;
  };

  const palletStock = stock?.pallet?.filter(p => p.pallet_batchno !== 'TOTAL') || [];

  return (
        <div className="product-card-ex">
            <div className="product-card-ex__header">
                <div className="product-card-ex__header__img">
                    <ProductImage imageCode={product?.product_sku} imageAlt={product?.quality_full_name}/>
                    <div className="product-card-ex__header__img__name">
                        <p className="product-card-ex__header__img__name__top">
                            Product Name: {product?.quality_full_name} {product?.colour_full_name}
                        </p>
                        <p className="product-card-ex__header__img__name__bottom">
                            {_.startCase(_.toLower(productType?.product_type_desc))}
                        </p>
                    </div>
                </div>
            </div>
            <div className="product-card-ex__sub-header">
                Select from packs or pallets
            </div>

            {/*<!-- PACKS -->*/}
            <div className="product-card-ex__accordion mt-3">
                <div className="product-card-ex__accordion__header">
                    <div className="product-card-ex__accordion__header__title">
                        Packs
                        <div className="font-small">1 Pack = {product?.sqm_per_box} SQM</div>
                    </div>
                    <div onClick={() => setTogglePack(!togglePack)} className="product-card-ex__accordion__header__toggle">
                        {!togglePack && <GrDown className="product-card-ex__caret"/>}
                        {togglePack && <GrUp className="product-card-ex__caret"/>}
                    </div>
                </div>
                {togglePack && <div className="product-card-ex__accordion__body">
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="product-card-ex__price__right">
                                {stock?.stock_availablity === 'yes' && <div className="green-circle"/>}
                                {stock?.stock_availablity === 'no' && <div className="red-circle"/>}
                                <div className="product-card-ex__price__right__details">
                                    <p className="text-start">
                                        {stock?.stock_availablity === 'yes' ? 'In Stock' : 'Out Of Stock'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {stock?.stock_availablity === 'no' && <div className="row mb-4">
                        <Button type="link" text="Notify When Back In Stock" onClick={onNotify} />
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row">
                        <div className="col-md-4 justify-content-center d-flex flex-column">
                            <div className="font-bold">Enter SQM</div>
                            <div className="font-small">Enter SQM Required</div>
                        </div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-8">
                                    <TextInput type="number" bgColor="white" onChange={setCurrentSQMPacks}
                                               value={currentSQMPacks}/>
                                </div>
                                <div className="col-4 justify-content-center d-flex flex-column border-start">
                                    SQM
                                </div>
                            </div>
                        </div>
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-4">
                        <div className="col-md-4 justify-content-center d-flex flex-column">
                            <div className="font-bold">Packs</div>
                            <div className="font-small">Based on your SQM</div>
                        </div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-8">
                                    <TextInput disabled type="number" bgColor="white" value={currentPacks}/>
                                </div>
                                <div className="col-4 justify-content-center d-flex flex-column border-start">
                                    Packs
                                </div>
                            </div>
                        </div>
                    </div>}

                    {stock?.stock_availablity === 'yes' && <div>
                        {/* @ts-ignore */}
                        {currentPacks > (totalQty - getLocalUsedPacks()) && <div className="mb-3 mt-3 alert alert-danger" role="alert">Max available packs: {totalQty - getLocalUsedPacks()}</div>}
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        <TextInput bgColor="white" placeholder="Example: Bedroom" required label="Reference" value={reference} onChange={setReference} />
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        <div className="col-3">
                            <span className="font-bold font-size-title">Total</span>
                        </div>
                        <div className="col-5">
                            <span className="font-bold text-orange font-size-title">
                            £{roundNumber((currentSQMPacks || 0) * (price?.unit_price || 0))}
                            </span>
                            <span className="text-small">&nbsp;&nbsp;Excl. VAT</span>
                        </div>
                        <div className="col-4 text-end">
                            <span className="font-bold text-orange font-size-title">
                                £{roundNumber((price?.unit_price || 0))}
                            </span>
                            <span className="text-small">&nbsp;&nbsp;per SQM</span>
                        </div>
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        {/* @ts-ignore */}
                        <Button text="Add To Order Summary" disabled={!currentSQMPacks || reference.length <= 0 || currentPacks > (totalQty - getLocalUsedPacks())} onClick={onAddPackToOrderSummary}/>
                    </div>}
                </div>}
            </div>

            {/*<!-- PALLETS -->*/}
            <div className="product-card-ex__accordion mt-3">
                <div className="product-card-ex__accordion__header">
                    <div className="product-card-ex__accordion__header__title">
                        Pallets
                    </div>
                    <div onClick={() => setTogglePallet(!togglePallet)} className="product-card-ex__accordion__header__toggle">
                        {!togglePallet && <GrDown className="product-card-ex__caret"/>}
                        {togglePallet && <GrUp className="product-card-ex__caret"/>}
                    </div>
                </div>
                {togglePallet && <div className="product-card-ex__accordion__body">
                    <div className="row">
                        <div className="col-12">
                            <div className="product-card-ex__price__right">
                                {palletStock.length > 0 && <div className="green-circle"/>}
                                {palletStock.length === 0 && <div className="red-circle"/>}
                                <div className="product-card-ex__price__right__details">
                                    <p className="text-start">
                                        {palletStock.length > 0 ? 'In Stock' : 'Out Of Stock'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {currentPallet && <div className="row mt-3">
                        <div className="col-md-4">
                            <div className="text-orange">Pallet ID: <b>{currentPallet.pallet_id}</b></div>
                        </div>
                    </div>}
                    {currentPallet && <div className="row mt-3">
                        <div className="col-md-4">
                            <div className="font-bold">Pallet Qty</div>
                            <div>{currentPallet.pallet_qty}</div>
                        </div>
                        <div className="col-md-4">
                            <div className="font-bold">Price</div>
                            <div>£{roundNumber(currentPallet.pallet_qty * (price?.pallet_price || 0))}</div>
                        </div>
                    </div>}
                    {palletStock.length > 0 && <div className="row mt-5">
                        <Button text="View All Available Pallets" type="grey" onClick={() => setTogglePalletPopUp(true)}/>
                        <LWModal title="All Available Pallets" onClose={() => setTogglePalletPopUp(false)}
                                 show={togglePalletPopUp}>
                            <div className="row">
                                {product && palletStock.slice(0, 12).map(r =>
                                    <div className="col-md-6 mb-4" key={r.pallet_id}>
                                        <MultiChoice.Pallets
                                            onClick={() => setCurrentPallet(r)}
                                            price={price?.pallet_price || 0}
                                            palletId={r.pallet_id}
                                            palletQty={r.pallet_qty}
                                            selected={r.pallet_id === currentPallet?.pallet_id}
                                        />
                                    </div>)}
                            </div>
                            {palletStock.length > 12 && <div className="row">
                                <p className="text-orange cursor-pointer mb-3 ps-3" onClick={() => setToggleMore(!toggleMore)}>View {toggleMore ? 'Less' : 'More'}</p>
                                <div className="row">
                                    {toggleMore && product && palletStock.slice(12, palletStock.length).map(r =>
                                        <div className="col-md-6 mb-4" key={r.pallet_id}>
                                            <MultiChoice.Pallets
                                                onClick={() => setCurrentPallet(r)}
                                                price={r.pallet_qty * (price?.pallet_price || 0)}
                                                palletId={r.pallet_id}
                                                palletQty={r.pallet_qty}
                                                selected={r.pallet_id === currentPallet?.pallet_id}
                                            />
                                        </div>)}
                                </div>
                            </div>}
                            <div className="row mt-5">
                                {currentPallet && <Button text="Add Pallet To Order Summary" onClick={onSelectPallet}/>}
                            </div>
                        </LWModal>
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div>
                        {/* @ts-ignore */}
                        {currentPallet?.pallet_qty > (totalQty - getLocalUsedPacks()) && <div className="mb-3 mt-3 alert alert-danger" role="alert">Max available packs: {totalQty - getLocalUsedPacks()}</div>}
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        <TextInput placeholder="Example: Bedroom" bgColor="white" label="Reference" required value={referencePallets} onChange={setReferencePallets} />
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        <div className="col-3">
                            <span className="font-bold font-size-title">Total</span>
                        </div>
                        <div className="col-5">
                            <span className="font-bold text-orange font-size-title">
                            £{roundNumber((currentPallet?.pallet_qty || 0) * (price?.pallet_price || 0))}
                            </span>
                            <span className="text-small">&nbsp;&nbsp;Excl. VAT</span>
                        </div>
                        <div className="col-4 text-end">
                            <span className="font-bold text-orange font-size-title">
                                £{roundNumber((price?.pallet_price || 0))}
                            </span>
                            <span className="text-small">&nbsp;&nbsp;per SQM</span>
                        </div>
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        <Button text="Add To Order Summary" disabled={!currentPallet || referencePallets.length <= 0 || currentPallet?.pallet_qty > (totalQty - getLocalUsedPacks())} onClick={onAddPalletToOrderSummary}/>
                    </div>}
                </div>}
            </div>

            {/*<!-- ORDER SUMMARY -->*/}
            <div className="product-card-ex__accordion mt-3">
                <div className="product-card-ex__accordion__header">
                    <div className="product-card-ex__accordion__header__title">
                        Order Summary
                    </div>
                </div>
                <div className="product-card-ex__accordion__body">
                    <div className="row">
                        <div className="col-12"><hr /></div>
                    </div>
                    {orderLines.map((o, i) => <div key={i} className="row mt-2 mb-4">
                        <div className="col-2">
                            <div className="text-small text-grey-tiny">Packs</div>
                            <div className="text-small">{o.quantity}</div>
                        </div>
                        <div className="col-4">
                            <div className="text-small text-grey-tiny">Price (per Pack)</div>
                            <div className="text-small">£{roundNumber(o?.item_price || 0)}</div>
                        </div>
                        <div className="col-4">
                            <div className="text-small text-grey-tiny">Total Excl. VAT</div>
                            <div className="text-small">£{roundNumber(o?.line_price || 0)}</div>
                        </div>
                        <div className="col-2">
                            <div className="text-small text-grey-tiny text-center">&nbsp;</div>
                            <div className="text-small d-flex justify-content-end align-items-center">
                                <div className="cursor-pointer" onClick={() => onMinus(i)}>
                                    <img src={TrashSvg} alt="trash" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-small text-grey-tiny">{o.product_quality} {o.colour_full_name} - Reference: {o.line_reference || 'N/A'} </div>
                        </div>
                    </div>)}
                    <div className="row">
                        <div className="col-12"><hr /></div>
                    </div>
                    <div className="row">
                        <div className="row">
                            <div className="col-6 font-bold"></div>
                            <div className="col-6 text-end">
                                <span className="font-bold text-small">Total&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span className="text-small">Excl. VAT &nbsp;&nbsp;&nbsp;</span>
                                <span className="font-bold text-orange">£{roundNumber(getOrderTotal())}</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <Button text="Add Order Summary to Basket and Continue Shopping" disabled={orderLines.length <= 0}
                                onClick={onAddOrderSummaryToBasketAndContinue}/>
                    </div>
                    <div className="row mt-4">
                        <Button text="Add Order Summary to Basket and Checkout" disabled={orderLines.length <= 0}
                                onClick={onAddOrderSummaryToBasket}/>
                    </div>
                </div>
            </div>
        </div>
  );
};

export default ProductCardEx;
